import Chartist from 'chartist';

/*
  This plugins changes how the labels of the X axis are displayed.
  There is a filter in the parameters to do this.
  It was created to have only the 1st and last labels on the X axis.
*/

(() => /* istanbul ignore next: chartist code */ {
  Chartist.plugins = Chartist.plugins || {};
  Chartist.plugins.wbOnlyXLabels = (labelFilter, options) => (chart) => {
    chart.on('created', (data) => {
      const labelGroup = chart.svg.querySelector('.ct-labels');
      const projectedValues = data.axisX.ticks.map(data.axisX.projectValue.bind(data.axisX));
      const labelValues = data.axisX.ticks.map(data.axisX.options.labelInterpolationFnc);

      projectedValues.forEach((projectedValue, index) => {
        if (labelFilter(projectedValues.length, index)) {
          const x = data.chartRect.x1 + data.axisX.options.labelOffset.x + projectedValue;
          const labelOffsetY = data.chartRect.y1 + data.axisX.options.labelOffset.y + 5;

          Chartist.createLabel(
            x,
            options.labelWidth,
            index,
            labelValues,
            data.axisX,
            data.axisX.options.offset,
            { x: index === 0 ? 0 : -options.labelWidth, y: labelOffsetY },
            labelGroup, [
              data.options.classNames.label,
              data.options.classNames[data.axisX.units.dir],
              index === 0 ? data.options.classNames.end : data.options.classNames.start,
            ],
            true,
            chart.eventEmitter,
          );
        }
      });
    });
  };
})();
